module.exports = __webpack_public_path__ + "media/images/ln/horoscope_3-d2f77102669296450f9375c996210c2b.png";